var map = {
	"./axepta/dark.json": 9554,
	"./axepta/light.json": 1410,
	"./default/base.json": 6093,
	"./default/dark.json": 9072,
	"./default/light.json": 4024,
	"./themes-registry.json": 4988,
	"./wlms/base.json": 8855,
	"./wlms/dark.json": 682,
	"./wlms/light.json": 666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1096;